export default __webpack_public_path__ + "src/assets/images/profile_pic.png";